export const getRoute = (route: string, baseRoute?: string): string => {
    baseRoute = baseRoute || '';
    return `${baseRoute}${route}`;
};

export const getAllRoutes = (baseRoute?: string): { [key: string]: string } => {
    // TODO: Add routes here
    return {
        ROOT: getRoute('', baseRoute),
        DASHBOARD: getRoute('/dashboard', baseRoute)
    };
};
